import { Typography } from "@mui/material";
import React from "react";

type OrderItemOptionProps = {
  className: string;
  fontSize: number;
  itemRenderString: string;
  categoryId: any;
};

export default function OrderItemOption({
  className,
  itemRenderString,
  categoryId,
}: OrderItemOptionProps) {
  return (
    <div key={categoryId}>
      <Typography
        variant="caption"
        className={className}
        style={{ display: "inline-block" }}
      >
        {itemRenderString}
      </Typography>
      <br />
    </div>
  );
}
